// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"ccbe2551","568":"f5fe205f"}[chunkId] + ".chunk.js";
};